// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_iQ","advertCardHeader__actions":"c-a_iR","advertCardHeader__bottomLabel":"c-a_iS"};